import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthGate } from "./components/AuthGate";
import { Sidebar } from "@/components/Sidebar";
import Hub from "@/pages/Hub";
import Workspace from "@/pages/Workspace";
import RecurringJournals from "@/pages/RecurringJournals";
import JournalEntryRegister from "@/pages/JournalEntryRegister";
import DuplicateRegister from "@/pages/DuplicateRegister";
import Accounts from "@/pages/Accounts";
import CompanySettings from "@/pages/admin/CompanySettings";
import EngineConfiguration from "@/pages/admin/EngineConfiguration";
import Reports from "@/pages/Reports";
import Readiness from "@/pages/Readiness";
import StatementLibrary from "@/pages/StatementLibrary";
import ChainCheck from "@/pages/ChainCheck";

function Shell({ children }) {
  return (
    <div className="app">
      <Sidebar />
      <main className="main">{children}</main>
    </div>
  );
}

function Placeholder({ title, blurb }) {
  return (
    <div data-testid={`page-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="heading h1">{title}</div>
      <div className="muted" style={{ marginTop: 8, marginBottom: 18, fontSize: 14 }}>{blurb}</div>
      <div className="empty">UI surface not yet authorized. The underlying data model and audit log already support this register — only the screen is pending Controller authorization.</div>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <AuthGate>
        <BrowserRouter>
          <Shell>
            <Routes>
              <Route path="/" element={<Hub />} />
              <Route path="/periods/:id" element={<Workspace />} />
              <Route path="/recurring-journals" element={<RecurringJournals />} />
              <Route path="/accounts" element={<Accounts />} />
              <Route path="/registers/caje" element={
                <JournalEntryRegister
                  kind="CAJE"
                  title="CAJE Register"
                  blurb="Control register that tracks Clearing Account Journal Entries posted in the ERP. Month-End Commander records the controller's confirmation; it does not post to the ERP."
                />
              } />
              <Route path="/registers/bsje" element={
                <JournalEntryRegister
                  kind="BSJE"
                  title="BSJE Register"
                  blurb="Control register that tracks Bank Statement Journal Entries posted in the ERP. Month-End Commander records the controller's confirmation; it does not post to the ERP."
                />
              } />
              <Route path="/registers/duplicates" element={<DuplicateRegister />} />
              <Route path="/statement-library" element={<StatementLibrary />} />
              <Route path="/audit/chain-check" element={<ChainCheck />} />
              <Route path="/admin/company-settings" element={<CompanySettings />} />
              <Route path="/admin/engine-configuration" element={<EngineConfiguration />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/readiness" element={<Readiness />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Shell>
        </BrowserRouter>
      </AuthGate>
    </div>
  );
}

export default App;
